import React from "react";
import styled from "styled-components";

const GenericComponentWrapper = styled.div`
  position: relative;
  /* display: inline-block; */
  /* padding: 10px 20px; */
  /* background-color: #007bff; */
  /* color: white; */
  /* border-radius: 5px; */
  cursor: pointer;
  height: fit-content;
  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const Tooltip = styled.div`
  visibility: hidden;
  background-color: rgba(0, 0, 53);
  color: #fff;
  max-width: 100px;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  font-size: x-small;
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`;

const TooltipButton = ({ children, tooltipText }) => {
  return (
    <GenericComponentWrapper>
      {children}
      <Tooltip className="tooltip">{tooltipText}</Tooltip>
    </GenericComponentWrapper>
  );
};

export default TooltipButton;
